import React, { Component } from 'react';
import TeamsCard from '../CardsTypesMundial/TeamsCard/index';
import './_styles.scss';
import {cls} from '../../../packages/components';
import { TEAMS } from '../../utls/constants';

export default class RibbonTeams extends Component {
  constructor(props) {
    super(props);
    this.isFlag = false;
    this.focusHandler = props.focusHandler;
    this.dataUpdateMetrics = props.dataUpdateMetrics;
    this.focusSettings = props.focusSettings;
    this.ribbonId = props.ribbonId;
    this.focusUp = props.focusUp;
    this.ribbonName = props.ribbonName;
    this.state = {  
      teams: this.orderCountry(props)
    }
  }

  orderCountry(list){
    return list.items;
  }

  componentDidMount() {
    window.SpatialNavigation.makeFocusable();
  }

  componentDidUpdate() {
    window.SpatialNavigation.makeFocusable();
  }

  render() {
    return (
    <div className={cls(`${TEAMS}-ribbon`)}>
      {this.state.teams.map((teamData, index) => {
        this.isFlag = index <= 4 ? true: false;
        const key = Math.random() * 10;
        const focusLeft = index % 6 === 0 ? '': undefined;
        const focusRight = index % 6 === 5 ? '': undefined;

        if(index <= 5) {
          return(
            <TeamsCard 
              unFocusHandler={this.unFocusHandler}
              focusHandler={this.focusHandler}
              key = { teamData.id }
              team={ teamData } 
              focusUp = {this.focusUp}
              focusLeft={focusLeft} 
              focusRight={focusRight} 
              id={index}
              isFlag = {this.isFlag}
            /> ) 
          }
        }
        )}
    </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/mundial/RibbonTypes/RibbonTeams/RibbonTeams.js